import React, { useState } from 'react';
import { Button, SvgIcon } from '@mui/material';
import DollarIMacIcon from '../../../../icons/dollar-imac.svg?react';
import HealthNotesIcon from '../../../../icons/health-notes.svg?react';
import HealthClassCalc from './HealthClassCalc';
import './HealthClassCalcButton.scss'

export default function HealthClassCalcButton(props) {

  const title = props.title || "NEEDS ANALYSIS";

  const [modalHealthCalcIsOpen, setModalHealthCalcIsOpen] = useState(false);

  const modalNeedsCalculatorFields = {
    modalHealthCalcIsOpen: modalHealthCalcIsOpen,
    setModalHealthCalcIsOpen: setModalHealthCalcIsOpen,
  };

  return (
    <div className="health-rating-button needs-analysis-button">
      <React.Fragment>
      <Button type="submit"
            onClick={() => setModalHealthCalcIsOpen(true)}
            variant={props.isPrequote ? undefined : "contained"}
            color="primary"
            className={`${props.isPrequote ? `button-white` : `quote-health-button button-white`}`}
          >
            {props.isPrequote ? <SvgIcon component={HealthNotesIcon} color="primary" /> : <div className="icon-container mb-0 background-color-16"><SvgIcon component={DollarIMacIcon} color="primary" /></div>}
            <span className="name">&nbsp;{title}</span>
          </Button>
        <HealthClassCalc fields={modalNeedsCalculatorFields} isPrequote={props.isPrequote} currentHealthClass={props.currentHealthClass} onHealthClassChange={props.onHealthClassChange} />
      </React.Fragment>
    </div>
  );
}
